import {setGetLoginAction} from '../action';
import { getLogin } from '../api/getLogin';

const setGetLogin = (params ) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getLogin(params);

            if (data.status === 'success') {
                dispatch(setGetLoginAction(data.users));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetLogin
}